module.exports = __webpack_public_path__ + "static/04-b7068a749f2b8a07dba7266cf7fef827.jpg";